import Skeleton from '@/components/dataDisplay/Skeleton';

const ContentDetailPlaceholder = () => {
  return (
    <div style={{ padding: 16, display: 'flex', flexDirection: 'column', flex: 1, gap: 16 }}>
      <div style={{ display: 'flex', gap: 16, alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', gap: 4, width: '60%' }}>
          <Skeleton width={32} height={32} style={{ borderRadius: '50%' }} />
          <Skeleton width="100%" height={32} />
        </div>
        <div style={{ display: 'flex', gap: 4 }}>
          <Skeleton width={32} height={32} style={{ borderRadius: '50%' }} />
          <Skeleton width={32} height={32} style={{ borderRadius: '50%' }} />
          <Skeleton width={32} height={32} style={{ borderRadius: '50%' }} />
        </div>
      </div>

      <Skeleton style={{ flex: 1 }} />
    </div>
  );
};

export default ContentDetailPlaceholder;
